import { WorkflowCollectAddressVerification } from "../components/collectAddress/WorkflowCollectAddressVerification";

export function CollectAddressPage() {
  return <WorkflowCollectAddressVerification />;
}
